document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("withdrawalForm");

  if (!form) return;

  const btn = form.querySelector(".withdrawal-btn");

  let submitted = false;


  /* =====================================================
     ERROR FUNCTIONS
     ===================================================== */

  function removeError(field) {

    field.style.borderColor = "";

    const error =
      field.parentNode.querySelector(".field-error");

    if (error) {
      error.remove();
    }

  }


  function showError(field, message) {

    removeError(field);

    const error =
      document.createElement("div");

    error.className = "field-error";

    error.innerText = message;

    error.style.color = "#d93025";
    error.style.fontSize = "13px";
    error.style.marginTop = "6px";

    field.style.borderColor = "#d93025";

    field.parentNode.appendChild(error);

  }


  function validEmail(email) {

    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  }


  /* =====================================================
     FORM SUBMIT
     ===================================================== */

  form.addEventListener("submit", function (e) {

    let valid = true;


    const firstname = form.firstname;
    const lastname = form.lastname;
    const email = form.email;
    const order = form.order;
    const product = form.product;

    const checkbox =
      document.getElementById("withdrawal_accept");


    /* ---------------------------------------------------
       REQUIRED FIELDS
       --------------------------------------------------- */

    [
      firstname,
      lastname,
      email,
      order,
      product

    ].forEach(function (field) {

      removeError(field);

      if (!field.value.trim()) {

        showError(
          field,
          "Dieses Feld ist erforderlich"
        );

        valid = false;

      }

    });


    /* ---------------------------------------------------
       EMAIL
       --------------------------------------------------- */

    if (
      email.value &&
      !validEmail(email.value)
    ) {

      showError(
        email,
        "Bitte geben Sie eine gültige E-Mail-Adresse ein."
      );

      valid = false;

    }


    /* ---------------------------------------------------
       CHECKBOX
       --------------------------------------------------- */

    if (
      !checkbox ||
      !checkbox.checked
    ) {

      alert(
        "Bitte bestätigen Sie die Widerrufsbelehrung."
      );

      valid = false;

    }


    /* ---------------------------------------------------
       STOP IF INVALID
       --------------------------------------------------- */

    if (!valid) {

      e.preventDefault();

      return;

    }


    /* ---------------------------------------------------
       PREVENT DOUBLE SUBMISSION
       --------------------------------------------------- */

    if (submitted) {

      e.preventDefault();

      return;

    }

    submitted = true;


    /* ---------------------------------------------------
       BUTTON
       --------------------------------------------------- */

    if (btn) {

      btn.disabled = true;

      btn.innerHTML =
        "Widerruf wird gesendet...";

    }


    /* ---------------------------------------------------
       REDIRECT
       
       The form continues submitting normally to the
       hidden iframe.
       
       After a few seconds, redirect the MAIN Shopify
       page to the confirmation page.
       --------------------------------------------------- */

    setTimeout(function () {

      window.location.href =
        "/pages/widerruf-bestatigen";

    }, 3000);


    /*
     * IMPORTANT:
     *
     * Do NOT call e.preventDefault() here.
     *
     * The browser must still submit the form to
     * Google Apps Script.
     */

  });

});